export default __webpack_public_path__ + "static/media/mitsubishi-logo.a59779f8.png";